<script setup>
import { computed } from 'vue'
import { useJobStore } from '@/stores/job'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'

const jobStore = useJobStore()
const router = useRouter()

const cutoff = dayjs('2025-11-09')
const jobsForFollowUp = computed(() => {
  return jobStore.jobs.filter((job) => {
    const updated = job.updatedAt ? dayjs(job.updatedAt) : dayjs(job.createdAt)
    if (updated.isBefore(cutoff)) return false
    // ביקור בתהליך או מתוכנן? לא נחשב דורש טיפול
    if (job.visits?.some((v) => ['בתהליך', 'מתוכנן'].includes(v.status))) return false

    // אם סומן כ"ללא חיוב", זה לא נחשב דורש טיפול
    if (job.isNonBillable) return false

    // מחיר חסר -> דורש טיפול
    if (!job.price) return true

    // חישוב סך התשלומים
    const totalPayments = job.payments?.reduce((sum, p) => sum + p.amount, 0) || 0

    // תשלום חסר או חלקי -> דורש טיפול
    if (totalPayments < job.price) return true

    // אחרת, הכל תקין
    return false
  })
})

// כאן נצטרך דרך לפתוח את ה-Wizard עבור עבודה ספציפית.
// פתרון אפשרי: להוסיף פרמטר ל-URL של JobView שיגרום לפתיחת הדיאלוג.
// לעת עתה, נפנה לדף העבודה.
const handleJobClick = (jobId) => {
  router.push(`/jobs/${jobId}`)
  // בעתיד: אפשר להוסיף query param כמו ?action=followup
  // ושהקומפוננטה JobView תזהה אותו ותפתח את הדיאלוג.
}

const getStatus = (job) => jobStore.getJobStatus(job)
const getSeverity = (job) => jobStore.getStatusSeverity(getStatus(job))
</script>

<template>
  <div v-if="jobsForFollowUp.length > 0" class="overflow-hidden">
    <Panel header="עבודות שממתינות לעדכון">
      <div class="flex max-h-96 flex-col gap-2 overflow-auto">
        <div class="text-primary-500 text-xs">
          מציג עבודות שעודכנו החל מתאריך {{ dayjs(cutoff).format('DD/MM/YYYY') }}
        </div>
        <div
          v-for="job in jobsForFollowUp"
          :key="job.id"
          class="hover:bg-surface-100 flex cursor-pointer items-center justify-between rounded border p-2"
          @click="handleJobClick(job.id)"
        >
          <div>
            <div class="font-semibold">{{ job.jobCategory?.name || job.name }}</div>
            <div class="text-sm text-gray-600">{{ job.customer?.name }}</div>
          </div>
          <div class="flex items-center gap-2">
            <Tag :value="getStatus(job)" :severity="getSeverity(job)" />
            <i class="pi pi-angle-left"></i>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>
